import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { SnackbarProvider } from "notistack";
import React from "react";

const MySnackbarProvider = ({ children }) => {
  const notistackRef = React.createRef();
  const onClickDismiss = (key: string) => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={5}
      action={(key) => (
        <IconButton onClick={() => onClickDismiss(key)}>
          <Close sx={{ color: "white" }} />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};

export default MySnackbarProvider;
